import LazyLoad from "react-lazyload";
import { ImageProps } from "src/types/contentfulTypes";

interface ComponentProps {
  imageObj: ImageProps;
  imageClass: string;
  height?: string;
}

const Image = ({ imageObj, imageClass, height = "100%" }: ComponentProps) => (
  <LazyLoad height={height} once={true}>
    <img src={imageObj.url} alt={imageObj.alt} className={imageClass} />
  </LazyLoad>
);

export default Image;
